import { useI18n } from '../i18n/I18nProvider';
import type { MessageKey } from '../i18n/i18n';
import { Icon, type IconName } from '../ui/Icon';

/**
 * 还没做的模块。**明说"还没做"，不摆假数据。**
 *
 * 假的活动列表、假的返佣数字看着像已经通了，等真接的时候才发现全是壳 ——
 * 而且演示的时候没人分得清哪些是真的。
 */
export function Placeholder(
  { icon, titleKey, noteKey }:
  { icon: IconName; titleKey: MessageKey; noteKey: MessageKey },
) {
  const { t } = useI18n();
  return (
    <section className="stack">
      <h1 className="h1">{t(titleKey)}</h1>
      <div className="placeholder">
        <Icon name={icon} className="placeholder__icon" />
        <p className="small placeholder__note">{t(noteKey)}</p>
      </div>
    </section>
  );
}
